import { $, $$, onReady, emit } from '../nth-ms26-core/js/env';

/*
 * Popup dùng chung (thay Fancybox): mở/đóng mượt, Esc, bấm nền để đóng, giữ focus trong popup,
 * trả focus về nút đã bấm. html.has-modal báo fullpage ngừng nhận lăn chuột.
 */
const FOCUSABLE = 'a[href], button:not([disabled]), iframe, video, [tabindex]:not([tabindex="-1"])';
let opener = null;

export function open(modal) {
  opener = document.activeElement;
  modal.hidden = false;
  document.documentElement.classList.add('has-modal');
  requestAnimationFrame(() => requestAnimationFrame(() => modal.classList.add('is-open')));
  const close = $('[data-modal-close].modal__close', modal);
  if (close) setTimeout(() => close.focus({ preventScroll: true }), 50);
}

export function close(modal) {
  if (!modal || modal.hidden) return;
  modal.classList.remove('is-open');
  setTimeout(() => {
    modal.hidden = true;
    const slot = $('[data-video-slot]', modal);
    if (slot && slot.firstChild) {
      slot.innerHTML = ''; // gỡ iframe = dừng hẳn video
      emit('nth:video', { open: false });
      document.documentElement.classList.remove('has-video');
    }
    if (!$$('[data-modal]').some((m) => !m.hidden)) document.documentElement.classList.remove('has-modal');
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }, 350);
}

// https://www.youtube.com/watch?v=ID | youtu.be/ID | /embed/ID | /shorts/ID
function youtubeId(url) {
  const m = String(url).match(/(?:youtu\.be\/|v=|\/embed\/|\/shorts\/)([\w-]{11})/);
  return m ? m[1] : null;
}

function openVideo(url) {
  const modal = $('#video-modal');
  const slot = modal && $('[data-video-slot]', modal);
  if (!slot) {
    window.open(url, '_blank', 'noopener');
    return;
  }
  const id = youtubeId(url);
  if (id) {
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`;
    iframe.title = 'Video';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    slot.appendChild(iframe);
  } else {
    const video = document.createElement('video');
    video.src = url;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    slot.appendChild(video);
  }
  document.documentElement.classList.add('has-video');
  emit('nth:video', { open: true });
  open(modal);
}

onReady(() => {
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-video]');
    if (trigger) {
      e.preventDefault();
      openVideo(trigger.getAttribute('href') || trigger.dataset.video);
      return;
    }
    const closer = e.target.closest('[data-modal-close]');
    if (closer) close(closer.closest('[data-modal]'));
  });

  document.addEventListener('keydown', (e) => {
    const modal = $$('[data-modal]').find((m) => !m.hidden);
    if (!modal) return;
    if (e.key === 'Escape') close(modal);
    if (e.key === 'Tab') {
      const nodes = $$(FOCUSABLE, modal).filter((n) => n.offsetParent !== null);
      if (!nodes.length) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // popup khuyến mãi tự mở sau khi trang tải xong
  $$('[data-modal-auto]').forEach((modal) => {
    const mode = modal.dataset.modalAuto;
    const key = 'nth-promo-seen';
    try {
      if (mode === 'session' && sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (err) { /* không lưu được thì cứ mở */ }
    window.addEventListener('load', () => setTimeout(() => open(modal), 900), { once: true });
  });
});
